import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as fa from '@fortawesome/free-solid-svg-icons'
import Loader from './Loader.js';
import './FaseSelect.css';

export default function FaseSelect(props) {
	const faseList = props.faseList;
	const startFase = faseList.find(element => parseInt(element.id) === parseInt(props.startFase));

	const [fase, setFase] = useState(startFase);
	const [showFasePopup, setShowFasePopup] = useState(false);

	// Sem fase, nao mostra nada
	if (!fase) {
		return <Loader text="FaseSelect"/>;
	}
	const faseIndex = faseList.indexOf(fase);

	const prevFase = () => {
		const newFaseIndex = faseList.indexOf(fase) - 1;
		if (faseList[newFaseIndex]) {
			setFase(faseList[newFaseIndex]);
		}
	};
	const nextFase = () => {
		const newFaseIndex = faseList.indexOf(fase) + 1;
		if (faseList[newFaseIndex]) {
			setFase(faseList[newFaseIndex]);
		}
	}

	return (
		<>
			{ faseList.length > 1 ?
				( <>
					<div className={"row title-fase e0" + (faseIndex === 0 ? " first-selected" : "") + (faseIndex === faseList.length-1 ? " last-selected" : "")}>
						<div className="button e0 left" onClick={prevFase}><FontAwesomeIcon icon={fa.faChevronLeft} /></div>
						<div className="e100 nome-fase" onClick={(e) => { setShowFasePopup(!showFasePopup); e.stopPropagation(); }}>
							<div data-show={showFasePopup} className="select-fase">
								<div>
								{faseList.map((thisFase) => {
									return <div className={thisFase === fase ? "selected" : ""} onClick={(e) => { setShowFasePopup(false); setFase(thisFase); e.stopPropagation();}}>{thisFase.name}</div>;
								})}
								</div>
							</div>
							{fase.name}
							<div className="select-icon">
								<FontAwesomeIcon icon={fa.faChevronDown}/>
							</div>
						</div>
						<div className="button e0 right" onClick={nextFase}><FontAwesomeIcon icon={fa.faChevronRight} /></div>
					</div>
					<div data-show={showFasePopup} className="select-fase-blackout" onClick={(e) => { setShowFasePopup(false); e.stopPropagation();}}></div>
				</> )
			:
				null
			}
			{props.render({fase})}
		</>
	);
}
